import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "font-semibold text-xl text-black-lp-100 border-b border-gray-lp-1300 w-full p-4 font-montserrat flex items-center justify-between" }
const _hoisted_2 = {
  class: "flex flex-col relative px-4",
  style: {"height":"calc(55vh / var(--viewport-scale)) !important"}
}
const _hoisted_3 = { class: "flex justify-end w-full px-6 py-4 shadow border-t border-gray-lp-400" }
const _hoisted_4 = { class: "w-48" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterModalArea = _resolveComponent("FilterModalArea")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableModalArea = _resolveComponent("TableModalArea")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.visible = $event)),
    persistent: "",
    customBody: "p-0",
    showOverflow: "",
    customWidth: "w-4/5"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, " Area " + _toDisplayString(_ctx.data.areaName), 1)
    ]),
    "main-footer": _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_LpButton, {
            color: "red-lp-100",
            textColor: "white",
            title: "Oke",
            isWidthFull: "",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.visible = false))
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_FilterModalArea, {
        modelValue: _ctx.params,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.params = $event)),
          _ctx.onFilter
        ]
      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
      _createVNode("div", _hoisted_2, [
        (_ctx.listData.errorType)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.listData.errorType,
              onTryAgain: _ctx.getList,
              customClass: "py-8"
            }, null, 8, ["errorType", "onTryAgain"]))
          : (!_ctx.listData.data.length && _ctx.isFiltering && !_ctx.listData.loading)
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 1,
                icon: "ill_spot_search",
                customHeaderMessage: "Hasil tidak ditemukan",
                customMessage: "Silahkan cek kata kunci Anda atau ubah filter ",
                customClass: "py-8"
              }))
            : (!_ctx.listData.data.length && !_ctx.listData.loading)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 2,
                  data: `data area ${_ctx.data.areaName}`,
                  customClass: "py-8"
                }, null, 8, ["data"]))
              : (_ctx.listData.data.length || _ctx.listData.loading)
                ? (_openBlock(), _createBlock(_component_TableModalArea, {
                    key: 3,
                    class: "mt-3",
                    column: _ctx.column,
                    data: _ctx.listData.data,
                    substractHeight: 361,
                    pagination: _ctx.params.pagination,
                    loading: _ctx.listData.loading,
                    orderBy: _ctx.params.orderBy,
                    "onUpdate:orderBy": _cache[2] || (_cache[2] = ($event: any) => (_ctx.params.orderBy = $event)),
                    sortBy: _ctx.params.sort,
                    "onUpdate:sortBy": _cache[3] || (_cache[3] = ($event: any) => (_ctx.params.sort = $event)),
                    page: _ctx.params.pagination.page,
                    "onUpdate:page": _cache[4] || (_cache[4] = ($event: any) => (_ctx.params.pagination.page = $event)),
                    onRequest: _ctx.getList
                  }, {
                    no: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.index + 1 + _ctx.offset), 1)
                    ]),
                    _: 1
                  }, 8, ["column", "data", "pagination", "loading", "orderBy", "sortBy", "page", "onRequest"]))
                : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}